module.exports = function(a){
	return a instanceof Array;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mutype/is-array.js
// module id = McKh
// module chunks = 0